import * as React from "react";
import styled from "@mui/material/styles/styled";
import { PatientCaseGrouping } from "../../../context/diagnosticAgent";
import { ReactComponent as ClinicalFinginsIcon } from "../../../assets/clinialFindingsIcon.svg";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { Button, Theme } from "@mui/material";

//region [[ Styles ]]

interface SectionTabSingleViewType {
  theme?: Theme;
  isselected: "true" | "false";
}

const SectionTabSingleView = styled(Button)(
  ({ theme, isselected }: SectionTabSingleViewType) => ({
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    paddingTop: `11px`,
    borderRadius: "0",
    background:
      isselected === "true" ? KahunColorMap.Primary : KahunColorMap.PrimaryDim,
    transition: "color, opacity 0.3s ease-in",
    "&:hover": {
      background:
        isselected === "true"
          ? KahunColorMap.Primary
          : KahunColorMap.PrimaryDim,
      "& .MuiButton-label": {
        opacity: 1,
      },
    },
    "& .MuiButton-label": {
      display: "flex",
      flexFlow: "column",
      opacity: isselected === "true" ? 1 : 0.6,
      transition: "opacity 0.3s ease-in",
    },
  }),
);

const TabTitle = styled("div")(({ theme }) => ({
  fontSize: "11px",
  fontWeight: 500,
  color: KahunColorMap.White,
  whiteSpace: "nowrap",
  textAlign: "center",
  transition: "color, opacity 0.3s ease-in",
  cursor: "pointer",
}));

const SectionIcon = styled("div")({
  fontSize: "30px",
  lineHeight: "0",
  marginBottom: "5px",
  color: KahunColorMap.White,
  cursor: "pointer",
  "& svg": {
    fill: KahunColorMap.White,
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SectionTabSingleProps {
  selected: boolean;
  section: PatientCaseGrouping;
  onClick: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SectionTabSingle = ({ ...props }: SectionTabSingleProps) => {
  const sections = {
    background: {
      label: "History",
      icon: <i className="fal fa-notes-medical" />,
    },
    clinicalFeatures: {
      label: "Clinical Findings",
      icon: <ClinicalFinginsIcon />,
    },
    workup: {
      label: "Workup",
      icon: <i className="fal fa-flask" />,
    },
  };

  return (
    <SectionTabSingleView
      onClick={props.onClick}
      className={"section-tab-single"}
      isselected={props.selected ? "true" : "false"}
    >
      <SectionIcon className={"section-icon"}>
        {sections[props.section].icon}
      </SectionIcon>
      <TabTitle className={"tab-title"}>
        {sections[props.section].label}
      </TabTitle>
    </SectionTabSingleView>
  );
};
